import jsPDF from "jspdf";

// Add watermark to each page (very faint)
// const addWatermark = (doc) => {
//   const pageCount = doc.internal.getNumberOfPages();
  
//   for (let i = 1; i <= pageCount; i++) {
//     doc.setPage(i);
//     doc.setTextColor(240, 240, 240); // Very light gray
//     doc.setFontSize(50);
//     doc.setFont("helvetica", "bold");
    
//     // Rotate and add diagonal watermark
//     doc.saveGraphicsState();
//     doc.text("CONFIDENTIAL", doc.internal.pageSize.width / 2, doc.internal.pageSize.height / 2, {
//       angle: 45,
//       align: 'center'
//     });
//     doc.restoreGraphicsState();
//   }
  
//   doc.setTextColor(0, 0, 0);
// };

// Add header/footer
const addHeaderFooter = (doc, title, isFinal = false, approvedBy = null) => {
  const policyTitle = title || "AML Policy";
  
  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text(policyTitle, 14, 20);

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 28);

  if (isFinal) {
    doc.setTextColor(0, 128, 0);
    doc.setFont("helvetica", "bold");
    doc.text("FINAL APPROVED VERSION", 150, 20);
    if (approvedBy && approvedBy.name) {
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");
      doc.text(`Approved By: ${approvedBy.name} (${approvedBy.designation})`, 14, 35);
    }
  } else {
    doc.setTextColor(200, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.text("DRAFT VERSION", 150, 20);
  }

  doc.setTextColor(0, 0, 0);
};

// Generate Draft PDF
export const generateDraftPDF = (policy, preparedBy = { name: "Admin L1", designation: "L1" }) => {
  const doc = new jsPDF();
  addHeaderFooter(doc, policy.name, false, preparedBy);
  addAMLContent(doc, preparedBy, false);
  // addWatermark(doc);
  
  // Set PDF to read-only (document permissions)
  doc.setProperties({
    title: policy.name,
    author: preparedBy.name,
    creator: "AMLi Policy Management System"
  });
  
  return doc.output("blob");
};

// Generate Final PDF
export const generateFinalPDF = (policy, approvedBy = { name: "Compliance Officer L2", designation: "L2" }) => {
  const doc = new jsPDF();
  addHeaderFooter(doc, policy.name, true, approvedBy);
  addAMLContent(doc, approvedBy, true);
  // addWatermark(doc);
  
  // Set PDF properties and protection
  doc.setProperties({
    title: policy.name + " - FINAL",
    author: approvedBy.name,
    creator: "AMLi Policy Management System"
  });
  
  return doc.output("blob");
};

// Add full AML content to PDF with justified alignment and procedure links
const addAMLContent = (doc, person, isFinal) => {
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("Anti-Money Laundering (AML) Policy Document", 14, 45);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Reference Document – For SME Compliance", 14, 52);

  const sections = [
    {
      title: "1. Purpose and Scope",
      content:
        "This Anti-Money Laundering (AML) Policy sets out the minimum requirements that must be followed by [Company Name] in compliance with UAE Federal Decree-Law No. (20) of 2018 on Anti-Money Laundering and Combating the Financing of Terrorism, Cabinet Decision No. (10) of 2019, FATF Recommendations, and Ministry of Economy DNFBP Rulebook. This policy applies to all employees, management, and business operations.",
      linkedProcedures: "Linked Procedures: Governance & Compliance Framework (Doc Ref: GOV-SOP-01)"
    },
    {
      title: "2. Key Principles",
      content:
        "Compliance First: Protecting our license and reputation is central to our business. Risk-Based Approach: We apply controls based on the risks of our customers, products, and transactions. Zero Tolerance: We do not deal with criminal proceeds, sanctioned parties, or entities linked to terrorism.",
      linkedProcedures: "Linked Procedures: Code of Conduct & Ethics Policy (Doc Ref: ETH-POL-01)"
    },
    {
      title: "3. Risk Assessment",
      content:
        "In line with UAE AML Law and FATF Recommendation 1, the Company will conduct a risk assessment to identify exposure across customers (e.g., high-net-worth individuals, cash-intensive businesses), products and services (e.g., gold, real estate), geographic locations (e.g., clients from high-risk jurisdictions), and delivery channels (e.g., non-face-to-face onboarding). The risk assessment will be documented and updated annually or when the business changes significantly.",
      linkedProcedures: "Linked Procedures: Enterprise-Wide Risk Assessment SOP (Doc Ref: RA-SOP-01)"
    },
    {
      title: "4. Customer Due Diligence (CDD)",
      content:
        "CDD must be carried out before starting a business relationship, when a transaction exceeds the legal threshold, or when there is suspicion of money laundering or terrorist financing. For individuals: Verify full name, nationality, Emirates ID/passport, address, and where needed, source of funds. For companies: Verify trade license, ownership structure, and details of UBOs holding 25% or more.",
      linkedProcedures: "Linked Procedures: CDD Process Flow - Individuals (Doc Ref: CDD-SOP-01), CDD Process Flow - Companies & UBOs (Doc Ref: CDD-SOP-02), Customer Risk Profiling Guide (Doc Ref: CDD-GUIDE-01)"
    },
    {
      title: "5. Enhanced Due Diligence (EDD)",
      content:
        "EDD is required for higher-risk customers such as Politically Exposed Persons (PEPs), customers from high-risk countries, and unusual or suspicious transactions. EDD may include requesting source of wealth/funds documentation, senior management approval, or more frequent monitoring.",
      linkedProcedures: "Linked Procedures: EDD Process & Senior Approval SOP (Doc Ref: EDD-SOP-01)"
    },
    {
      title: "6. Ongoing Monitoring",
      content:
        "All customers and transactions are subject to ongoing monitoring to identify unusual patterns. Monitoring includes continuous screening against updated sanctions and PEP lists, periodic review of customer risk profiles, and alerts for suspicious transactions.",
      linkedProcedures: "Linked Procedures: Transaction Monitoring Workflow (Doc Ref: MON-SOP-01)"
    },
    {
      title: "7. Record Keeping",
      content:
        "As per UAE AML Law and FATF Recommendation 11, customer documents, transaction data, and STRs must be retained for at least five (5) years. Records must be easily retrievable and made available to regulators within two (2) business days upon request.",
      linkedProcedures: "Linked Procedures: Record Retention & Retrieval SOP (Doc Ref: RK-SOP-01), Audit Trail Database Guide (Doc Ref: RK-DB-01)"
    },
    {
      title: "8. Sanctions & PEP Screening",
      content:
        "All customers must be screened against relevant sanctions lists: UAE Local Terrorist List, UN Consolidated List, OFAC, EU. Screening must also cover Politically Exposed Persons (PEPs). Screening is performed at onboarding and daily on an ongoing basis. Positive matches must be escalated to the MLRO immediately.",
      linkedProcedures: "Linked Procedures: Sanctions & PEP Daily Screening SOP (Doc Ref: SANC-SOP-01)"
    },
    {
      title: "9. Suspicious Transaction Reporting (STRs)",
      content:
        "Any staff member who identifies suspicious activity must escalate immediately to the MLRO. The MLRO will review, document, and, if necessary, file an STR via the goAML portal. All STRs will be securely recorded for audit purposes.",
      linkedProcedures: "Linked Procedures: STR Escalation Process (Doc Ref: STR-SOP-01), goAML Reporting SOP (Doc Ref: STR-SOP-02), Internal STR Register Template (Doc Ref: STR-REG-01)"
    },
    {
      title: "10. Governance & AML Officer",
      content:
        "The Board/Owners approve this AML Policy. The Company will designate a Compliance Officer / MLRO as required by law. The MLRO is responsible for implementing this policy, reporting to regulators, and ensuring staff are trained.",
      linkedProcedures: "Linked Procedures: MLRO Role & Responsibilities SOP (Doc Ref: MLRO-SOP-01)"
    },
    {
      title: "11. Training & Awareness",
      content:
        "All staff must complete AML training annually and at onboarding. Training will cover Customer Due Diligence (CDD), Enhanced Due Diligence (EDD), sanctions screening, reporting suspicious activity, and emerging money laundering risks relevant to our sector.",
      linkedProcedures: "Linked Procedures: Staff Training Calendar & Modules (Doc Ref: TRN-CAL-01), Training Attendance Log (Doc Ref: TRN-LOG-01)"
    },
  ];

  let y = 65;
  const maxWidth = 182;
  const lineHeight = 5;

  sections.forEach((sec) => {
    // Check if we need a new page before starting section
    if (y > 250) {
      doc.addPage();
      y = 20;
    }

    // Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text(sec.title, 14, y);
    y += 8;

    // Content - Justified
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    
    const lines = doc.splitTextToSize(sec.content, maxWidth);
    
    lines.forEach((line) => {
      if (y > 275) {
        doc.addPage();
        y = 20;
      }
      doc.text(line.trim(), 14, y, { maxWidth: maxWidth, align: 'left' });
      y += lineHeight;
    });
    
    y += 3;

    // Linked Procedures - Italic, smaller font
    if (sec.linkedProcedures) {
      if (y > 270) {
        doc.addPage();
        y = 20;
      }
      doc.setFont("helvetica", "italic");
      doc.setFontSize(9);
      doc.setTextColor(60, 60, 60);
      const procLines = doc.splitTextToSize(sec.linkedProcedures, maxWidth);
      procLines.forEach((line) => {
        if (y > 275) {
          doc.addPage();
          y = 20;
        }
        doc.text(line.trim(), 14, y);
        y += lineHeight;
      });
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
    }
    
    y += 8; // Extra space between sections
  });

  // Add signature section at the end
  if (y > 240) {
    doc.addPage();
    y = 30;
  } else {
    y += 15;
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Document Control", 14, y);
  y += 10;
  
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  if (!isFinal) {
    doc.text(`Prepared By: ${person.name}`, 14, y);
    doc.text(`Designation: ${person.designation}`, 14, y + 7);
    doc.text(`Date: ${new Date().toLocaleDateString()}`, 14, y + 14);
  } else {
    doc.text(`Approved By: ${person.name}`, 14, y);
    doc.text(`Designation: ${person.designation}`, 14, y + 7);
    doc.text(`Approval Date: ${new Date().toLocaleDateString()}`, 14, y + 14);
  }
  
  // Add footer note
  y += 25;
  if (y > 270) {
    doc.addPage();
    y = 20;
  }
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text("This document is generated by AMLi Policy Management System and is subject to regulatory compliance.", 14, y);
  doc.text("For internal use only. Unauthorized distribution is prohibited.", 14, y + 5);
};